module.exports = __webpack_public_path__ + "static/media/clinic_icon.d8c72242.svg";